import { render } from "./NotFoundView.vue?vue&type=template&id=50e0346f&scoped=true"
import script from "./NotFoundView.vue?vue&type=script&lang=js"
export * from "./NotFoundView.vue?vue&type=script&lang=js"

import "./NotFoundView.vue?vue&type=style&index=0&id=50e0346f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50e0346f"]])

export default __exports__